import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  computed,
  inject,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Observable } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';

import { Post } from 'src/app/core/models/core.models';
import { PostDetailsService } from 'src/app/core/services/post-details.service';
import { UtilsService } from 'src/app/core/services/utils.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-post-full-content',
  templateUrl: './post-full-content.component.html',
  styleUrls: ['./post-full-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PostFullContentComponent implements OnInit, OnChanges {
  @Input() postId: string;

  private readonly postDetails = inject(PostDetailsService);

  /** The post this tab is showing - the pane pushes it through `ngOnChanges`. */
  private readonly shownPostId = signal<string | null>(null);

  // Built once - `toObservable` needs an injection context.
  post$: Observable<Post> = toObservable(
    computed(() => this.postDetails.postFor(this.shownPostId())),
  );
  postLoading$: Observable<boolean> = toObservable(
    computed(() => this.postDetails.isLoadingFor(this.shownPostId())),
  );

  postUrlInternal: string;

  protected utilsService = inject(UtilsService);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['postId'] && this.postId) {
      this.loadPostData(this.postId);
    }
  }

  ngOnInit(): void {
    if (this.postId) {
      this.loadPostData(this.postId);
    }
  }

  private loadPostData(postId: string): void {
    this.shownPostId.set(postId);
    this.postUrlInternal =
      environment.baseUrl + '/post/view/?post_id=' + postId;
  }

  copyToClipboard(text: string): void {
    this.utilsService.copyToClipboard(text);
  }

  openInNewTab(url: string): void {
    window.open(url, '_blank');
  }
}
